<template>
  <div>
    <!-- 모달 컨텐츠 -->
    <div class="modal__contents">
      <div class="modal__middlebox">
        <div class="modal__row">
          <h2 class="subtitle subtitle--modal">
            참고 할 파일을 업로드 해주세요
          </h2>
        </div>
        <div class="modal__row">
          <div class="formfield__row">
            <div class="formfield__inputitem">
              <div
                class="fileattach"
                :data-state="fileState"
              >
                <label
                  class="fileattach__label"
                  :data-message="dataMessage"
                >
                  <input
                    ref="files"
                    v-model="filename"
                    class="fileattach__input"
                    type="text"
                    name="attachfile"
                    :disabled="attachFileState"
                    multiple
                    @change="handleFileUploads()"
                    @dragover.prevent
                    @dragenter.prevent
                    @drop.prevent="addFile"
                    @click="$refs.file.click()"
                  >
                </label>
                <input
                  ref="file"
                  type="file"
                  class="addfile"
                  multiple
                  @change="addFile"
                >
                <ul
                  class="fileattach__list"
                >
                  <li
                    v-for="(file, index) in files"
                    :key="index"
                    class="fileattach__item"
                  >
                    <span class="fileattach__name">{{ file.name }}</span>
                    <button
                      @click="removeFile(file)"
                    >
                      <span>x</span>
                    </button>
                  </li>
                </ul>
                <button
                  class="fileattach__clear"
                  type="button"
                  @click="removeAllFile"
                >
                  전체삭제
                </button>
                <p class="guidetext guidetext--file">
                  파일당 최대 10MB, 5개 까지 등록 가능
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal__bottombox">
        <div class="checkbox">
          <input
            id="check"
            ref="attachTbd"
            v-model="req.attachFiles.tbd"
            class="checkbox__input"
            type="checkbox"
            name="check"
            @change="attachTbd"
          >
          <label
            class="checkbox__label"
            for="check"
          >
            업로드 할 파일이 없습니다.
          </label>
        </div>
      </div>
    </div>
    <!-- 모달 푸터(bottom) -->
    <div class="modal__footer">
      <ul class="modal__buttons">
        <li class="modal__buttonitem">
          <button
            class="button button--large button--secondary"
            @click="save"
          >
            임시저장
          </button>
        </li>
        <li class="modal__buttonitem">
          <button
            class="button button--large"
            :disabled="!req.attachFiles.tbd && !files.length"
            @click="next"
          >
            다음
          </button>
        </li>
      </ul>
    </div>
    <div class="modal__prevbutton">
      <button
        class="button button--function"
        @click="$emit('prev-step')"
      >
        이전
      </button>
    </div>
  </div>
</template>
<script>
export default{
  name:'Attachfiles',
  props: {
    request: {
      type: Object,
      required: true
    }
  },
  emits: ['prev-step','next-step', 'save-click'],
  data(){
    return {
      req: this.request,
      filename: '',
      fileState: '',
      files: [],
      attachFileState: false,
      dataMessage:'마우스로 파일을 끌어오거나 선택하세요'
    }
  },
  mounted() {
    const files = this.req.attachFiles.files
    console.log(files, files[0])
    if (files && files[0]) {
      if (files[0].name) {  // LocalStorage에는 파일 객체가 저장되지 않으므로 임시저장된 경우가 아닌 뒤로 가기 일때만 파일 표시
        this.files = files
        this.fileState = 'drag'
      } else {
        this.req.attachFiles.files = []
      }
    }
  },
  methods:{
    addFile(event) {
      if(!this.$refs.attachTbd.checked){
        let addedFiles
        if(event.dataTransfer){
          addedFiles = event.dataTransfer.files;
        } else {
          addedFiles = event.target.files;
        }
        if(!addedFiles) return;
        for( var i = 0; i < addedFiles.length; i++ ){
          if(this.files.length < 5){
            if(addedFiles[i].size <= 10485760){
              this.files.push(addedFiles[i]);
            } else {
              alert('파일 한개당 10MB를 초과할 수 없습니다')
              return false
            }
          } else {
            alert('업로드 가능 개수를 초과하였습니다.')
            return false
          }
        }
        if(this.files.length > 0) {
          this.fileState = 'drag'
        }
        this.$refs.file.value=null;
      }
    },
    removeFile(file){
      this.files = this.files.filter(f => {
        return f != file;
      });
      if(this.files.length == 0) {
        this.fileState = ''
      }
    },
    removeAllFile() {
      this.files = []
      this.fileState = ''
    },
    handleFileUploads() {
      this.files = this.$refs.files.files;
    },
    attachTbd() {
      if(this.$refs.attachTbd.checked){
        this.removeAllFile()
        this.attachFileState = true
        this.dataMessage = '업로드하려면 아래 체크 상태를 해제하세요'
      } else {
        this.dataMessage = '마우스로 파일을 끌어오거나 선택하세요'
      }
    },
    next() {
      this.req.attachFiles = {
        files: this.files
      }
      //다음페이지 이동
      this.$emit('next-step')
    },
    save() {
      this.$emit('save-click')
    }
  }
}
</script>
<style lang="scss" scoped>
.modal{
  $self:&;
  &__middlebox{
    width:500px;
  }
  &__buttons{
    width:330px;
    margin:0 auto;
    &:after{
      content:'';
      clear:both;
      display:inline;
    }
  }
  &__buttonitem{
    float:left;
    width:160px;
    height:50px;
    &:not(:first-child){
      margin-left:10px;
    }
  }
}
.formfield{
  $self:&;
  &__inputitem{
    width:500px;
    height:128px;
  }
}
.addfile {
  width:1px;
  height:1px;
  opacity: 0;
  position:absolute;
}
</style>